import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useEffect } from "react"
import { SheetViewer } from "routes/asset-register/plugins/excel-import/sheet-viewer"
import { RowSelector } from "routes/asset-register/plugins/excel-import/row-selector"
import { useTarget } from "lib/@hooks/use-target"
import { range } from "lib/range"
import { Card } from "@mui/material"

export function ChooseHeaderRow({ canContinue, setOptional, setContinueFunction, optional }) {
    const target = useTarget()
    const [sheet] = useBoundValue("importFromSheet")
    const [row, setRow] = useBoundValue("headerRow")
    const [headers, setHeaders] = useBoundValue("headers")
    const [, setInterpretedSheet] = useBoundValue("interpretedSheet")
    const [, setUniqueValues] = useBoundValue("uniqueValues")
    useEffect(() => {
        setContinueFunction(getSheetData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [row, setContinueFunction, sheet, headers])
    useEffect(() => {
        setOptional(optional)
        if (row !== undefined) {
            const sheetRow = sheet.getRow(row)
            const headers = []
            for (let column = 1; column < sheetRow.actualCellCount + 1; column++) {
                const cell = sheetRow.getCell(column)
                const name = cell.value
                if (name) {
                    headers.push({
                        column,
                        name,
                    })
                }
            }
            setHeaders(headers)
            canContinue(true)
        } else {
            canContinue(false)
        }
    }, [canContinue, optional, row, setHeaders, setOptional, sheet])

    return (
        <Card sx={{ mb: 1, mt: 2 }}>
            <SheetViewer
                sx={{ maxHeight: 216 }}
                sheet={sheet}
                firstColumn={<RowSelector selected={row} onChange={changeRow} />}
            />
        </Card>
    )

    function getSheetData() {
        if (!headers || typeof row !== "number") return
        const rows = sheet.getRows(row + 1, sheet.rowCount - row)
        const uniqueValues = {}
        const sheetData = rows.map((row) =>
            headers.reduce((a, header) => {
                let value = row.getCell(header.column)?.value
                if (value && typeof value === "object" && "result" in value) {
                    value = value?.result ?? "Lookup failed"
                }
                const values = (uniqueValues[header.name] ??= {})
                values[value] = (values[value] ?? 0) + 1
                return {
                    ...a,
                    [header.name]: value,
                }
            }, {})
        )
        setUniqueValues(uniqueValues)
        setInterpretedSheet(sheetData)
        setOptional(`Row ${row}`)
    }

    function changeRow(row) {
        target.fields = {}
        target.previewOk = null
        target.headers = null
        target.interpretedSheet = null
        target.uniqueValues = null
        target.existingMapping = null
        range(2, 5).forEach((step) => {
            target.ok[step] = null
        })
        setRow(row)
    }
}
